export function getPurchaseFormatName(formatsAvailable) {
  const purchaseFormatName = Object.keys(formatsAvailable).find((format) => {
    return formatsAvailable[format]['isFormatPurchase'] === true;
  });

  return purchaseFormatName;
}

export function getBasicFormatsNames(formatsAvailable): string[] {
  const basicFormatNames: string[] = [];
  let minimalUnitFound = false;

  let currentFormatName = getPurchaseFormatName(formatsAvailable);
  while (!minimalUnitFound) {
    basicFormatNames.push(currentFormatName);
    if (formatsAvailable[currentFormatName]['subFormat'] === undefined) {
      minimalUnitFound = true;
    } else {
      currentFormatName = formatsAvailable[currentFormatName]['subFormat'];
    }
  }

  return basicFormatNames;
}

export function getCustomizedFormatNames(
  formatsAvailable,
  basicFormatNames
): string[] {
  const customizedFormatNames: string[] = Object.keys(formatsAvailable).filter(
    (formatName) => !basicFormatNames.includes(formatName)
  );
  return customizedFormatNames;
}
